export default class SocketService {
  // 单例
  static instance = null;
  static get Instance() {
    if (!this.instance) {
      this.instance = new SocketService();
    }
    return this.instance;
  }

  ws = null;
  //储存回调函数
  callBackMapping = {};

  connect() {
    if (!window.WebSocket) {
      return console.log("不支持websocket");
    }
    this.ws = new WebSocket("ws://49.4.68.207:5080/websocket");
    // 连接成功事件
    this.ws.onopen = () => {
      console.log("成功了");
    };
    // 连接失败事件
    this.ws.onclose = () => {
      console.log("失败了");
    };
    //得到数据
    this.ws.onmessage = msg => {
      // console.log("从服务端拿到的数据");
      const recvData = JSON.parse(msg.data);
      const socketType = recvData.c;
      // console.log(socketType);
      //判断回调函数是否存在
      if (this.callBackMapping[socketType]) {
        const action = recvData.d;
        console.log("成功");
        console.log(this.callBackMapping[socketType]);
      } else {
        console.log("没有回调");
        console.log(this.callBackMapping);
      }
    };
  }
  //回调函数注册
  registerCallBack(socketType, callBack) {
    this.callBackMapping[socketType] = callBack;
  }
  //回调函数的取消
  unRegisterCallBack(socketType) {
    this.callBackMapping[socketType] = null;
  }
  //发送数据
  send(data) {
    this.ws.send(JSON.stringify(data));
  }
}



// WEBPACK FOOTER //
// ./src/utils/socket.js